import React from "react"
import { Link } from "gatsby"
import MapIcon from "../../images/map-icon-white.png"
import BgTravel from "../../images/word-travel.jpg"

const WorkTravel = () => {
  return (
    <section
      className="bg-cover bg-center bg-no-repeat text-white"
      style={{ backgroundImage: `url(${BgTravel})` }}
    >
      <div className="bg-opacity-50 bg-primary">
        <div className="container mx-auto px-6 pt-24 pb-8 lg:pb-32 font-bold flex flex-wrap">
          <div className="flex-1 w-2/3">
            <h3 className="text-6xl md:text-5xl lg:text-7xl pb-5 font-medium">
              <span className="block font-bold text-shadow">Work &</span> Travel
            </h3>
            <h4 className="text-4xl md:text-3xl lg:text-4xl pb-5 font-extralight text-shadow">
              Travel with us, develop your genius, and live unique experiences!
            </h4>
          </div>
          <div className="w-1/3">
            <img src={MapIcon} alt="Work & Travel" />
          </div>
          <div>
            <p className="pb-8 w-full md:w-2/3 font-light text-shadow">
              If you want to make friends, be part of the family and live unique
              moments, AVALITH Work & Travel is for you.
            </p>
            <Link to="/careers/work-and-travel" className="border-white border-solid border-2 hover:bg-neutral hover:text-variant hover:text-primary btn">Get to know us</Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WorkTravel
